const Lawyer = () => import('./Lawyer.vue')
const LawyerInfo = () => import('./LawyerInfo.vue')
const LawyerForInfo = () => import('./LawyerForInfo.vue')
const LawyerPaInfo = () => import('./LawyerPaInfo.vue')
const Institute = () => import('./Institute.vue')
const InstituteInfo = () => import('./InstituteInfo.vue')
const Institute4Info = () => import('./Institute4Info.vue')
const CaseDetail = () => import('./CaseDetail.vue')
const CheckTime = () => import('./CheckTime.vue')
const PrivateLawyer = () => import('./PrivateLawyer.vue')
const PrivateInfo = () => import('./PrivateInfo.vue')
const LawAndPrivate = () => import ('./LawAndPrivate.vue')
const LecturerInfo = () => import ('./LecturerInfo.vue')
// const Accompany = () => import ('./Accompany.vue')
// const AccompanyInfo = () => import ('./AccompanyInfo.vue')
const LawWithPrivate = () => import ('./LawWithPrivate.vue')
const LawAndPrivateYj = () => import ('./LawAndPrivateYj.vue')
const LawAndPrivatePa = () => import ('./LawAndPrivatePa.vue')

export {
  Lawyer,
  LawyerInfo,
  LawyerForInfo,
  LawyerPaInfo,
  Institute,
  InstituteInfo,
  Institute4Info,
  CaseDetail,
  CheckTime,
  PrivateLawyer,
  PrivateInfo,
  LawAndPrivate,
  LecturerInfo,
  LawWithPrivate,
  // Accompany,
  // AccompanyInfo,
  LawAndPrivateYj,
  LawAndPrivatePa
}



// WEBPACK FOOTER //
// ./src/pages/lawyer/index.js